var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9B6212C3-A31D-424A-A49D-90164ECDA943") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BackOffice",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_Atendente-comercial_menu-2",
    transform: "translate(-165.000000, -121.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Menu",
    transform: "translate(0.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(92.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(1)-copy-2",
    transform: "translate(73.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,8.8 L14.7,2 C14.9,1.8 14.9,1.6 14.9,1.4 C14.9,1.2 14.8,1 14.7,0.8 L14.2,0.3 C13.9,1.33226763e-15 13.4,1.33226763e-15 13,0.3 L7.5,6 L1.8,0.2 C1.7,0.1 1.5,0 1.3,0 C1,0 0.8,0.1 0.7,0.2 L0.2,0.7 C0,0.9 0,1.1 0,1.3 C0,1.5 0.1,1.7 0.2,1.9 L6.9,8.8 C7,8.9 7.2,9 7.5,9 C7.7,9 7.9,8.9 8,8.8 Z",
    id: "Path_1_"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.5e136658.svg";
export { ForwardRef as ReactComponent };